import { RerateShipment } from "~/features/rerate/index.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const ShipmentReRatePage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxLtlShipmentRerate");

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled ? <RerateShipment /> : <Construction />;
};
